module.exports = "<div class=\"d-flex flex-column justify-content-center align-items-center w-100 mb-4\"><div class=header-text-register-as><div>Select a</div><div>competence area</div></div><div class=button-block><button ng-repeat=\"role in $ctrl.group.sub_roles track by role.id\" ng-if=\" role.id !=='33' && role.id !=='11' && role.id !=='12'\" ng-click=\"$ctrl.selectRole($event, role)\" class=\"btn btn-register-as\">{{role.id == 31 ? \"Company\" : role.name }}</button></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states_mobile/auth/components/register-as/register-as.component.html
// module id = 988
// module chunks = 31